// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_jo-0";